// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__9n9sv"};